// Redux
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

// Types
import { UsersUserProfileLanguageChoices } from "@/api/graphql/types"

// Env
import { DEFAULT_LANG } from "@/lib/env"

export interface UserPreferencesState {
	lang: UsersUserProfileLanguageChoices
	showInvestmentBanner: boolean
}

export const initialState: UserPreferencesState = {
	lang: DEFAULT_LANG,
	showInvestmentBanner: true,
}

const userPreferencesSlice = createSlice({
	name: "preferences",
	initialState,
	reducers: {
		setLang: (
			state,
			action: PayloadAction<UsersUserProfileLanguageChoices>,
		) => {
			state.lang = action.payload
		},
		setShowInvestmentBanner: (state, action: PayloadAction<boolean>) => {
			state.showInvestmentBanner = action.payload
		},
	},
})

// Action creators are generated for each case reducer function
export const { setLang, setShowInvestmentBanner } = userPreferencesSlice.actions

export default userPreferencesSlice.reducer
